'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.buildQueriesForResourceFactory = exports.defaultOptions = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _templates;

var _lodash = require('lodash.merge');

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = require('lodash.pickby');

var _lodash4 = _interopRequireDefault(_lodash3);

var _pluralize = require('pluralize');

var _pluralize2 = _interopRequireDefault(_pluralize);

var _fetchSchema = require('./fetchSchema');

var _fetchSchema2 = _interopRequireDefault(_fetchSchema);

var _buildQueriesForResource = require('./buildQueriesForResource');

var _buildQueriesForResource2 = _interopRequireDefault(_buildQueriesForResource);

var _listMutationsFromSchema = require('./listMutationsFromSchema');

var _listMutationsFromSchema2 = _interopRequireDefault(_listMutationsFromSchema);

var _listResourcesFromSchema = require('./listResourcesFromSchema');

var _listResourcesFromSchema2 = _interopRequireDefault(_listResourcesFromSchema);

var _listQueriesFromSchema = require('./listQueriesFromSchema');

var _listQueriesFromSchema2 = _interopRequireDefault(_listQueriesFromSchema);

var _constants = require('../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var REQUIRED_RESOURCE_KEYS = [_constants.GET_LIST, _constants.GET_ONE];

var isValidResource = function isValidResource(value) {
    return REQUIRED_RESOURCE_KEYS.every(function (requiredKey) {
        return Object.keys(value).some(function (resourceKey) {
            return resourceKey === requiredKey && !!value[resourceKey];
        });
    });
};

var defaultOptions = exports.defaultOptions = {
    includeTypes: null,
    excludeTypes: null,
    includeQueries: null,
    excludeQueries: null,
    includeMutations: null,
    excludeMutations: null,
    excludeFields: null,
    templates: (_templates = {}, (0, _defineProperty3.default)(_templates, _constants.GET_LIST, function (resourceType) {
        return 'getPageOf' + (0, _pluralize2.default)(resourceType.name);
    }), (0, _defineProperty3.default)(_templates, _constants.GET_ONE, function (resourceType) {
        return 'get' + resourceType.name;
    }), (0, _defineProperty3.default)(_templates, _constants.CREATE, function (resourceType) {
        return 'create' + resourceType.name;
    }), (0, _defineProperty3.default)(_templates, _constants.UPDATE, function (resourceType) {
        return 'update' + resourceType.name;
    }), (0, _defineProperty3.default)(_templates, _constants.DELETE, function (resourceType) {
        return 'remove' + resourceType.name;
    }), _templates)
};

var buildQueriesForResourceFactory = exports.buildQueriesForResourceFactory = function buildQueriesForResourceFactory(fetchSchemaImpl, listResourcesFromSchemaImpl, listQueriesFromSchemaImpl, listMutationsFromSchemaImpl, buildQueriesForResourceImpl) {
    return function () {
        var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
            var userOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultOptions;
            var options, schema, resourceTypes, queries, mutations, resources, result;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            options = defaultOptions;


                            if (typeof userOptions === 'string') {
                                options.url = userOptions;
                            }

                            if ((typeof userOptions === 'undefined' ? 'undefined' : (0, _typeof3.default)(userOptions)) === 'object') {
                                options = (0, _lodash2.default)({}, defaultOptions, userOptions);
                            }

                            _context.next = 5;
                            return fetchSchemaImpl(options.client);

                        case 5:
                            schema = _context.sent;
                            resourceTypes = listResourcesFromSchemaImpl(schema, options);
                            queries = listQueriesFromSchemaImpl(schema, options);
                            mutations = listMutationsFromSchemaImpl(schema, options);
                            resources = resourceTypes.reduce(function (queriesByResource, resourceType) {
                                return (0, _extends4.default)({}, queriesByResource, (0, _defineProperty3.default)({}, resourceType.name, buildQueriesForResourceImpl(resourceType, [].concat((0, _toConsumableArray3.default)(queries), (0, _toConsumableArray3.default)(mutations)), options)));
                            }, {});
                            result = (0, _lodash4.default)(resources, isValidResource);
                            return _context.abrupt('return', result);

                        case 12:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined);
        }));

        return function () {
            return _ref.apply(this, arguments);
        };
    }();
};

exports.default = buildQueriesForResourceFactory(_fetchSchema2.default, _listResourcesFromSchema2.default, _listQueriesFromSchema2.default, _listMutationsFromSchema2.default, _buildQueriesForResource2.default);


//////////////////
// WEBPACK FOOTER
// ./~/aor-simple-graphql-client/lib/introspection/index.js
// module id = 478
// module chunks = 0